export class ImageToReplace {
  public content: string;
  public width: number;
  public height: number;
}
